import { createFileRoute } from "@tanstack/react-router";

import { useViewer } from "../data/hooks.ts";
import { vaultSearch } from "../shell/search.ts";
import { NoAccessPage, NotFoundPage } from "../shell/status-pages.tsx";
import { loadVault } from "../vault/loaders.ts";
import { VaultPending } from "../vault/pending.tsx";
import { canAddVaultItems } from "../vault/permissions.ts";
import { VaultPage } from "../vault/vault-page.tsx";

import type { ReactElement } from "react";

const Page = (): ReactElement => {
  const viewer = useViewer();
  if (viewer === null) {
    return <NoAccessPage />;
  }
  return canAddVaultItems(viewer) ? <VaultPage viewer={viewer} /> : <NotFoundPage />;
};

export const Route = createFileRoute("/_app/vault/")({
  validateSearch: vaultSearch,
  loader: async ({ context }) => loadVault(context.data),
  pendingComponent: VaultPending,
  component: Page,
});
